// components/CustomizedListBuilding.js
// import Image from 'next/image'

import BookACallButton from './Buttons/Specials/BookACallButton'
import { ContainerWrapper } from './Container'
import SectionHeading from './HomePage/SectionHeading'

export default function BulletPointsCard({
    title,
    alignment,
    bulletPoints = [],
    imagePath,
    imageAlt,
    imageTitle,
    mobileImagePath,
    bg = 'bg-transparent',
    superHeading,
    callAction = false,
    CallActionButton = BookACallButton,
    CallActionText = 'Book Your FREE Coaching Call',
    size = 'xl',
    iconBg = 'bg-olm-light-yellow',
    bulletColor = 'primary',
    bulletSeperateDesc = false,
    extraCallAction = true,
}) {
    const alignmentClass =
        alignment === 'left' ? 'order-last lg:ml-10' : 'lg:mr-10'

    const shouldAddPadding = bg == 'bg-transparent' ? false : true

    return (
        <div className={`${bg} rounded-8xl md:rounded-8xl`}>
            <ContainerWrapper>
                {superHeading}
                <div
                    className={`${shouldAddPadding && 'pb-12 md:py-16'}
                    ${size === 'xl' ? 'md:max-w-5xl m-auto' : 'md:max-w-full'}
                    px-4 md:px-0 lg:flex lg:items-center lg:justify-between space-y-10 lg:space-y-0`}>
                    <div className="block md:hidden px-2 text-center">
                        <SectionHeading size={size}>{title}</SectionHeading>
                    </div>

                    <div className="mt-8 w-full md:hidden lg:w-5/12">
                        <img
                            src={mobileImagePath}
                            alt={imageAlt}
                            title={imageTitle}
                            className="w-full h-auto"
                        />
                    </div>
                    <div
                        className={`w-full px-2 md:px-0 lg:w-6/12 md:pl-0 mx-auto text-center lg:text-left ${alignmentClass}`}>
                        <div className="hidden md:block">
                            <SectionHeading size={size}>
                                <p className="text-left">{title}</p>
                            </SectionHeading>
                        </div>
                        <div className="mt-8 space-y-6">
                            {bulletPoints &&
                                bulletPoints.length > 0 &&
                                bulletPoints.map((Point, index) => (
                                    <div
                                        key={index}
                                        className="flex items-start space-x-3">
                                        <span
                                            className={`inline-block ${iconBg} p-2 rounded-full text-${bulletColor}`}>
                                            <Point.icon />
                                        </span>
                                        <div className="text-left">
                                            <p className="mt-1 text-xl space-x-1 text-black">
                                                <span className="text-xl leading-6 font-bold text-black">
                                                    {Point.title}:
                                                </span>
                                                {bulletSeperateDesc ? (
                                                    <p> {Point.description} </p>
                                                ) : (
                                                    <span>
                                                        {Point.description}
                                                    </span>
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            {callAction && (
                                <div className="space-y-2 max-w-full">
                                    <CallActionButton>
                                        {CallActionText}
                                    </CallActionButton>
                                    {extraCallAction && (
                                        <p className="olm-gradient-text italic font-semibold text-center">
                                            Limited Time Offer
                                        </p>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="mt-8 w-full hidden md:block lg:w-5/12">
                        <img
                            src={imagePath}
                            title={imageTitle}
                            alt={imageAlt}
                            className="w-full h-auto"
                        />
                    </div>
                </div>
            </ContainerWrapper>
        </div>
    )
}
